<template lang="html">
  <div class="form-group">
    <label v-if="label" for="firstName">{{ label }}</label>
    <input
      :class="[customClass, {'base-input-error-outline': errorMessage }]"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('enter', keyUpOnEnterCallback)" />
      <div v-if="errorMessage" class="base-input-error">{{ errorMessage[0] }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    value: { default: '' }, // can be different types of values
    type: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    customClass: { type: String, default: 'form-control' },
    keyUpOnEnterCallback: { type: Function, required: false },
    errorMessage: {
      default: null
    }
  }
}
</script>

<style lang="scss">
.base-input-error-outline {
  outline: none;
  border: 1px solid red;
}
.base-input-error {
  color: red;
  margin-top: 0.25rem;
  font-size: 80%;
}
</style>
